// app/javascript/controllers/custom_resource_category_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["primary", "secondary"]

  connect() {
    this.loadInitialValues()
  }

  loadSubcategories(event) {
    const parentId = event.target.value
    const secondarySelect = this.secondaryTarget
    secondarySelect.innerHTML = `<option value="">Select ${secondarySelect.dataset.label}</option>`

    if (!parentId) return

    const resourceTypeId = this.data.get("resourceTypeId")

    fetch(`/admin/custom_resource_types/${resourceTypeId}/categories/subcategories?parent_id=${parentId}`)
      .then(resp => resp.json())
      .then(data => {
        data.forEach(cat => {
          const option = document.createElement("option")
          option.value = cat.id
          option.textContent = cat.name
          secondarySelect.appendChild(option)
        })

        // Preselect secondary if editing
        const initialValues = JSON.parse(this.data.get("initialValues") || "{}")
        if (initialValues.secondary_category_id) {
          secondarySelect.value = initialValues.secondary_category_id
        }
      })
  }

  loadInitialValues() {
    const initialValues = JSON.parse(this.data.get("initialValues") || "{}")
    if (initialValues.primary_category_id) {
      this.primaryTarget.value = initialValues.primary_category_id
      this.primaryTarget.dispatchEvent(new Event('change'))
    }
  }
}